import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsFilledInfoCircle = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM10 8C10.5523 8 11 8.44772 11 9V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V9C9 8.44772 9.44771 8 10 8Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default PdsFilledInfoCircle;
